/**
 * Validate if its a valid email.
 * @param {String} userEmail - User's provided email.
 * @return {Boolean} - True if valid or false if not valid
 * @public
 */
export function isValidEmail(userEmail) {
  let emailPattern = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
  return typeof userEmail === "string" && emailPattern.test(userEmail);
}
